import React from "react";
import TimeCard from "./screens/TimeCard";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AdminDashboard from "./screens/AdminDashboard";
import LoginScreen from "./screens/LoginScreen";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/:personalurl" element={<TimeCard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/" element={<LoginScreen />} />
      </Routes>
    </Router>
  );
};
export default App;
